import { gql } from "@apollo/client"

export const getAllCMSContentQuery = gql`
  query getCMSContent(
    $searchString: String
    $pageNumber: Float
    $pageLimit: Float
  ) {
    getAllCMSContent(
      searchString: $searchString
      pageNumber: $pageNumber
      pageLimit: $pageLimit
    ) {
      items {
        id
        name
        content
        error {
          statusCode
          message
        }
      }

      pagination {
        pageNumber
        pageLimit
        totalCount
      }
    }
  }
`
export const deleteCMSContentMutation = gql`
  mutation deleteCMSContent($id: Int!) {
    deleteOneCMSContent(id: $id) {
      id
      status
      error {
        message
      }
    }
  }
`
export const getOneCMSContentQuery = gql`
  query getCMSContent($id: Int!) {
    getOneCMSContent(id: $id) {
      id
      name
      content
      keyName
      createdBy
      createdDateTime
      lastUpdatedBy
      lastUpdatedDateTime
    }
  }
`
export const createCMSContentMutation = gql`
  mutation createCMSContent($data: cmsContentInput) {
    createOneCMSContent(data: $data) {
      id
      status
      error {
        message
      }
    }
  }
`
export const updateCMSContentMutation = gql`
  mutation updateCMSContent($id: Int!, $data: cmsContentInput) {
    updateOneCMSContent(id: $id, data: $data) {
      id
      status
      error {
        message
      }
    }
  }
`
